export const data = [{
  id: 1,
  title: 'Can the THG reward be automatically used for staking?',
  content: 'No. The reward will be in the "waiting to be claimed" status and will not be automatically staked.'
}, {
  id: 2,
  title: 'Is it possible for THG holders to stake with different options at the same time?',
  content: `Absolutely! Many staking sessions are allowed at the same time. It's similar to when you put your money in the bank many times, the maturity for each time is different for each time`
}, {
  id: 3,
  title: 'Is the interest going to be paid monthly or in one time',
  content: `The interest will be paid every 10 seconds, and users can withdraw it to their in-game wallet everyday. Each withdrawal will be 24 hours apart.`
}, {
  id: 4,
  title: 'What are the fees applied when participating in THG Staking?',
  content: `When participating in THG Staking, actions regarding staking, unstaking, and claiming the rewards will be free of charge
            A fee will be applied when the users use the private tickets to participate in Private Sales, which is 20% of the total amount spent on each Private Sale and paid in THC. All the THC collected from the all the Private Sales will be burned, and Thetan Arena will not be eligible for any benefits from Private Sales)`
}, {
  id: 5,
  title: "Where do Private Sales come from? Are they Thetan Arena's new projects?",
  content: `
      - The projects' Private Sales don't belong to Thetan Arena

      - To yield more benefits for those users who go with the Stake & Lock option, Thetan Arena will purchase a large amount of tokens with high ROI from reliable projects, which are backed by large funds, such as Multicoin, Alameda Research, etc, and distribute them to the users.

      - With the 2-3 monthly Private Sales frequency, THG Staking will bring a lot of incentives for the community to use the feature
    `
}, {
  id: 6,
  title: 'Where can I find other questions?',
  content: `You can see more frequently asked questions here: https://wolffun.helpshift.com/hc/en/3-thetan-arena/section/18-thg-staking/`
}];